import { render, staticRenderFns } from "./HorizontalNavMenuModified.vue?vue&type=template&id=54986279&"
import script from "./HorizontalNavMenuModified.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuModified.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuModified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports